import { API } from '../Api';

// Lịch sử donate CÔNG KHAI của 1 creator — dùng ở profile để làm bằng chứng xã hội.
// Endpoint public (không cần đăng nhập). Người donate chọn ẩn danh sẽ hiện "Người ẩn danh".
const base = '/v1/payment-service/public/creator-donations';

export interface CreatorDonationItem {
  donater: string;
  donaterUserId: string | null; // null khi ẩn danh (hoặc tài khoản đã xoá)
  isAnonymous: boolean;
  message: string | null;
  amount: number; // số Ca creator thực nhận
  donatedAt: string;
  postId: string | null;
  campaignTitle?: string | null; // có giá trị khi đây là ủng hộ chiến dịch
}

export interface CreatorDonationsPage {
  totalItems: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  items: CreatorDonationItem[];
}

export const getCreatorDonations = (
  userId: string,
  pageNumber = 1,
  pageSize = 10
) =>
  API.get<CreatorDonationsPage>(base, {
    params: { userId, pageNumber, pageSize },
  }).then((r) => r.data);
